import {ProfessionnelClient as ProfessionnelClientV1, SollicitationClient} from "./generated";
import {ProfessionnelClient as ProfessionnelClientV2} from "./generated.v2";
import {IConfig} from "./authorization";
import {ConfigPublicClient} from "./generated.v2.public";

const {telemedecineBaseUrl: securedUrl, monSisraPublicBaseUrl: publicUrl} = window.config.endpoints;

const iConfig = new IConfig();

export const MonSisraApis = {
	professionnel: new ProfessionnelClientV1(iConfig, securedUrl),
	professionnelV2: new ProfessionnelClientV2(iConfig, securedUrl),
	sollicitation: new SollicitationClient(iConfig, securedUrl),
	config: new ConfigPublicClient(iConfig, publicUrl)
};
